import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from '../assets/images/banner.png';

const MartynsLaw = () => {
  // Calculate exact days remaining until 01 May 2027
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    const targetDate = new Date('2027-05-01T00:00:00');
    const today = new Date();
    const differenceInTime = targetDate.getTime() - today.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    setDaysRemaining(differenceInDays > 0 ? differenceInDays : 0);
  }, []);

  return (
    <div className="martyns-law-page">
      
      {/* INJECTED STYLES FOR HIGH-END EDITORIAL UI & MOBILE RESPONSIVENESS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .services-hero::after {
            display: none !important;
          }

          /* --- STRICT LEFT-ALIGNED ENTERPRISE ROWS --- */
          .enterprise-row {
            display: flex;
            width: 100%;
            margin: 0;
            padding: 0;
          }
          
          .enterprise-col-left {
            flex: 1 1 50%;
            text-align: left !important;
            padding: 0 4rem 0 0 !important;
            margin: 0 !important;
          }
          
          .enterprise-col-right {
            flex: 1 1 50%;
            text-align: left !important;
            padding: 0 0 0 4rem !important;
            margin: 0 !important;
          }

          .flush-left {
            margin-left: 0 !important;
            padding-left: 0 !important;
            text-align: left !important;
          }

          .hairline-divider {
            height: 1px;
            background-color: rgba(0, 0, 0, 0.1);
            margin: 6rem 0;
            width: 100%;
          }

          /* --- EDITORIAL TYPOGRAPHY --- */
          .ed-label {
            display: block;
            font-size: var(--fs-small);
            font-weight: 800;
            color: var(--color-secondary-grey);
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 1.5rem;
          }

          .ed-value {
            font-size: 6.5rem;
            font-weight: 800;
            color: var(--color-primary-navy);
            line-height: 0.85;
            letter-spacing: -3px;
            margin-bottom: 1rem;
            display: flex;
            align-items: baseline;
            gap: 0.5rem;
          }

          .ed-unit {
            font-size: 2rem;
            font-weight: 600;
            color: var(--color-secondary-grey);
            letter-spacing: 0;
            text-transform: lowercase;
          }

          .ed-desc {
            font-size: var(--fs-body);
            color: var(--color-secondary-grey);
            line-height: var(--lh-body);
            margin: 0;
            max-width: 90%;
          }

          .ed-heading {
            font-size: var(--fs-h2);
            line-height: 1.1;
            color: var(--color-primary-navy);
            letter-spacing: -1.5px;
            margin: 0;
          }

          .ed-subheading {
            font-size: var(--fs-h3);
            font-weight: 700;
            color: var(--color-primary-navy);
            letter-spacing: -0.5px;
            margin-bottom: 0.8rem;
          }

          /* --- SEAMLESS TIERING GRID --- */
          .seamless-tier-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            border-top: 2px solid var(--color-primary-navy);
            padding-top: 3rem;
            width: 100%;
          }

          .seamless-tier-col {
            padding-right: 3rem;
            border-right: 1px solid rgba(0,0,0,0.1);
            text-align: left !important;
          }

          .seamless-tier-col:last-child {
            padding-right: 0;
            border-right: none;
            padding-left: 3rem;
          }
          
          .seamless-tier-col:nth-child(2) {
            padding-left: 3rem;
          }

          /* --- NAVY VALUE CARDS --- */
          .value-navy-card {
            background: var(--color-primary-navy);
            border-radius: 12px;
            padding: 3rem 2.5rem;
            position: relative;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            display: flex;
            flex-direction: column;
            height: 100%;
            text-align: left !important;
            transition: none !important;
          }
          
          .value-navy-card:hover {
            transform: none !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
          }

          /* --- FAQ BLOCKS --- */
          .faq-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 4rem 3rem;
            width: 100%;
          }

          .faq-block {
            border-top: 1px solid rgba(0,0,0,0.1);
            padding-top: 1.5rem;
            text-align: left !important;
          }

          .check-list li {
            position: relative;
            padding-left: 2rem;
            margin-bottom: 1.2rem;
            color: var(--color-secondary-grey);
            font-size: var(--fs-body);
            line-height: var(--lh-body);
            text-align: left !important;
          }
          
          .check-list li::before {
            content: '—';
            position: absolute;
            left: 0;
            top: 0;
            color: var(--color-primary-navy);
            font-weight: bold;
          }

          /* Default desktop nowrap */
          .hero-nowrap { white-space: nowrap; }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .enterprise-row { flex-direction: column; }
            .enterprise-col-left { padding-right: 0 !important; margin-bottom: 4rem !important; }
            .enterprise-col-right { padding-left: 0 !important; border-left: none !important; }
            
            .seamless-tier-grid { grid-template-columns: 1fr; border-top: none; gap: 3rem; padding-top: 0; }
            .seamless-tier-col, .seamless-tier-col:last-child, .seamless-tier-col:nth-child(2) { 
              padding: 0; 
              border-right: none; 
              border-top: 2px solid var(--color-primary-navy); 
              padding-top: 2rem; 
            }
            .faq-grid { grid-template-columns: 1fr; gap: 3rem; }
            .ed-value { font-size: 5rem; }
            .ed-unit { font-size: 1.5rem; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .hero-nowrap { white-space: normal; } 
            .services-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .services-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .services-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce global container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            .ed-heading { font-size: 2.2rem !important; }
            
            /* Fix CTA layout overlapping screen edges */
            .sleek-cta-banner-override { flex-direction: column !important; text-align: center !important; padding: 3rem 1.5rem !important; }
            .sleek-cta-banner-override > div { min-width: 100% !important; text-align: center !important; }
            .sleek-cta-banner-override p { margin: 0 auto !important; }
          }
        `}
      </style>

      {/* 1. HERO SECTION */}
      <section className="services-hero">
        <div className="container text-center">
          <h1><span className="hero-nowrap">Ready For Martyn's Law ?</span></h1>
          <p className="subtitle" style={{ maxWidth: '900px', margin: '0 auto', fontSize: 'var(--fs-h3)' }}>
            Proven by Nightmark. The Terrorism (Protection of Premises) Act 2025 is expected to come into force in Spring 2027. By utilising the guides and information on this page it will support your journey towards compliance in Spring 2027.
          </p>
        </div>
      </section>

      {/* 2 & 3. URGENCY & CONTEXT (ENTERPRISE ROW LAYOUT) */}
      <section className="container" style={{ paddingTop: '8rem', paddingBottom: '8rem' }}>
        
        {/* Top Row: Unbounded Metrics */}
        <div className="enterprise-row">
          <div className="enterprise-col-left flush-left">
            <span className="ed-label">Deadline</span>
            <div className="ed-value">
              {daysRemaining} <span className="ed-unit">days</span>
            </div>
            <p className="ed-desc">
              The critical window to move from basic awareness to evidence-backed readiness before the Spring 2027 enforcement.
            </p>
          </div>
          
          <div className="enterprise-col-right" style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.15)' }}>
            <span className="ed-label">Speed to Insight</span>
            <div className="ed-value">
              30 <span className="ed-unit">days</span>
            </div>
            <p className="ed-desc">
              Our rapid readiness audit timeline delivers a comprehensive and board-ready compliance readout in under a month.
            </p>
          </div>
        </div>

        {/* Hairline Divider */}
        <div className="hairline-divider"></div>

        {/* Bottom Row: Contextual Authority */}
        <div className="enterprise-row">
          <div className="enterprise-col-left flush-left">
            <span className="ed-label">Why This Matters Now</span>
            <h2 className="ed-heading">Start before need becomes urgency.</h2>
          </div>
          
          <div className="enterprise-col-right" style={{ paddingTop: '0.5rem' }}>
            <div style={{ marginBottom: '3.5rem' }}>
              <h3 className="ed-subheading">From awareness to evidence</h3>
              <p className="ed-desc">
                Time is running out. Royal assent is done and businesses must now move to an active preparation to meet the needs. Owners, operators and responsible persons have a narrowing runway to turn the broad awareness of document procedures, training records and evidence into compliant outcomes and plans.
              </p>
            </div>
            <div>
              <h3 className="ed-subheading">Designed for confidence</h3>
              <p className="ed-desc">
                By working with us, we will remove time pressure and give you a delivery model that is easy to work with, relatable and simple to understand.
              </p>
            </div>
          </div>
        </div>

      </section>

      {/* 4. WHO IS IN SCOPE (SEAMLESS TIERING) */}
      <section className="bg-light" style={{ paddingTop: '8rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="flush-left" style={{ marginBottom: '5rem', maxWidth: '800px' }}>
            <span className="ed-label">Who Is In Scope</span>
            <h2 style={{ fontSize: 'var(--fs-h2)', color: 'var(--color-primary-navy)', letterSpacing: '-1.5px', marginBottom: '1.5rem', lineHeight: '1.1' }}>
              Simple tiering for venues, estates and multi-site portfolios.
            </h2>
            <p className="ed-desc">
              This quick guide will allow you to identify the probable tier for your business before booking your consultation with us.
            </p>
          </div>

          <div className="seamless-tier-grid">
            <div className="seamless-tier-col">
              <span className="ed-label">Capacity &lt; 200</span>
              <h3 style={{ fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)', marginBottom: '1rem', letterSpacing: '-0.5px' }}>Out of Scope</h3>
              <p className="ed-desc">
                Still advisable to follow standard tier procedures, especially in higher-risk locations.
              </p>
            </div>

            <div className="seamless-tier-col">
              <span className="ed-label">Capacity 200 - 799</span>
              <h3 style={{ fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)', marginBottom: '1rem', letterSpacing: '-0.5px' }}>Standard Tier</h3>
              <p className="ed-desc">
                Notify the SIA and put public protection procedures in place for evacuation, invacuation, lockdown and communication.
              </p>
            </div>

            <div className="seamless-tier-col">
              <span className="ed-label">Capacity 800+</span>
              <h3 style={{ fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)', marginBottom: '1rem', letterSpacing: '-0.5px' }}>Enhanced Tier</h3>
              <p className="ed-desc">
                All of the above, plus a documented security plan, formal risk assessment, proportionate measures and a named senior responsible person.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. WHAT NIGHTMARK DELIVERS */}
      <section style={{ paddingTop: '8rem', paddingBottom: '8rem', backgroundColor: 'var(--color-white)' }}>
        <div className="container">
          
          <div className="enterprise-row" style={{ marginBottom: '6rem', alignItems: 'center' }}>
            <div className="enterprise-col-left flush-left">
              <span className="ed-label">What Nightmark Delivers</span>
              <h2 className="ed-heading">A practical path from first audit to ongoing compliance.</h2>
            </div>
            <div className="enterprise-col-right">
              <ul className="check-list" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li>Audit, procedures, training and monitored response are grouped together to give you one clear and easily understood price.</li>
                <li>We have designed all our evidence packs and board ready outputs specifically for you rather than generic advisory.</li>
                <li>Our Security Operations Centre (SOC) and embedded standards will ensure that your compliance and adherence to the regulations is where they need to be. We are not simply a policy writer, we partner with your team ensuring compliance with the law.</li>
              </ul>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '2rem' }}>
            <div className="value-navy-card">
               <span style={{ color: 'var(--color-secondary-light)', textTransform: 'uppercase', fontSize: 'var(--fs-small)', letterSpacing: '1px', marginBottom: '0.5rem', fontWeight: '700' }}>Fixed-Fee Audit</span>
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Readiness Audit</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'rgba(255,255,255,0.75)', lineHeight: 'var(--lh-body)' }}>Working to your needs, we will tier your sites, map every gap and produce a prioritised 90-day plan.</p>
            </div>

            <div className="value-navy-card">
               <span style={{ color: 'var(--color-secondary-light)', textTransform: 'uppercase', fontSize: 'var(--fs-small)', letterSpacing: '1px', marginBottom: '0.5rem', fontWeight: '700' }}>Full Programme</span>
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Compliance Programme</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'rgba(255,255,255,0.75)', lineHeight: 'var(--lh-body)' }}>After an initial audit, we develop procedures, plans, training, tabletop exercise and a clause-by-clause evidence pack.</p>
            </div>

            <div className="value-navy-card">
               <span style={{ color: 'var(--color-secondary-light)', textTransform: 'uppercase', fontSize: 'var(--fs-small)', letterSpacing: '1px', marginBottom: '0.5rem', fontWeight: '700' }}>Retained Support</span>
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Managed Compliance Retainer</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'rgba(255,255,255,0.75)', lineHeight: 'var(--lh-body)' }}>Our dedicated consultancy team ensures you continue to position your organisation periodically.</p>
            </div>

            <div className="value-navy-card">
               <span style={{ color: 'var(--color-secondary-light)', textTransform: 'uppercase', fontSize: 'var(--fs-small)', letterSpacing: '1px', marginBottom: '0.5rem', fontWeight: '700' }}>Modular Training</span>
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Tabletop Exercises</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'rgba(255,255,255,0.75)', lineHeight: 'var(--lh-body)' }}>Standalone or embedded training modules aligned to the SIA-facing evidence standard outlined in the regulation and legislation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. WHY NIGHTMARK */}
      <section className="container" style={{ paddingTop: '8rem', paddingBottom: '8rem' }}>
        <div className="enterprise-row" style={{ alignItems: 'center' }}>
          <div className="enterprise-col-left flush-left">
            <span className="ed-label">Why Nightmark</span>
            <h2 className="ed-heading" style={{ marginBottom: '2.5rem' }}>Built around Operations, Evidence and Accountability.</h2>
            <div 
              style={{ 
                backgroundImage: 'url("https://imgur.com/bwphhHB.png")', 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                width: '100%', 
                minHeight: '400px', 
                borderRadius: '12px'
              }}
            ></div>
          </div>
          
          <div className="enterprise-col-right">
            <div style={{ marginBottom: '3.5rem' }}>
              <h3 className="ed-subheading">Operated, not just written</h3>
              <p className="ed-desc">
                Nightmark Group operates its own control centre giving you a safer, more controlled environment 24/7, 365 days a year.
              </p>
            </div>
            
            <div style={{ marginBottom: '3.5rem' }}>
              <h3 className="ed-subheading">Standards-led delivery</h3>
              <p className="ed-desc">
                Aligned with current regulations and the Terrorism (Protection of Premises) Act 2025 by design.
              </p>
            </div>

            <div>
              <h3 className="ed-subheading">Sector relevance</h3>
              <p className="ed-desc">
                The night-time economy, venues, student accommodation and education estates are probably the three most exposed sectors that will be affected by the legislation. We have specifically designed solutions for those environments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 7. FAQ / OBJECTIONS */}
      <section className="bg-light" style={{ paddingTop: '8rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="flush-left" style={{ marginBottom: '6rem', maxWidth: '800px' }}>
            <span className="ed-label">FAQs</span>
            <h2 className="ed-heading">Addressing your concerns.</h2>
          </div>

          <div className="faq-grid">
            <div className="faq-block">
              <span className="ed-label" style={{ color: 'var(--color-primary-navy)', marginBottom: '0.5rem' }}>Timing</span>
              <h3 className="ed-subheading" style={{ marginBottom: '1rem' }}>When does Martyn's Law come into force?</h3>
              <p className="ed-desc">
                Spring 2027 is the earliest expected date, giving organisations time to move from awareness into evidence-backed readiness.
              </p>
            </div>

            <div className="faq-block">
              <span className="ed-label" style={{ color: 'var(--color-primary-navy)', marginBottom: '0.5rem' }}>Regulation</span>
              <h3 className="ed-subheading" style={{ marginBottom: '1rem' }}>Who enforces it?</h3>
              <p className="ed-desc">
                The Security Industry Authority as regulator, with enforcement powers and a guidance role that operators should track closely.
              </p>
            </div>

            <div className="faq-block">
              <span className="ed-label" style={{ color: 'var(--color-primary-navy)', marginBottom: '0.5rem' }}>Scope</span>
              <h3 className="ed-subheading" style={{ marginBottom: '1rem' }}>Does it apply to student accommodation?</h3>
              <p className="ed-desc">
                Yes - the outreach draft explicitly states that higher education settings and relevant off-site student accommodation can fall within scope.
              </p>
            </div>

            <div className="faq-block">
              <span className="ed-label" style={{ color: 'var(--color-primary-navy)', marginBottom: '0.5rem' }}>Personnel</span>
              <h3 className="ed-subheading" style={{ marginBottom: '1rem' }}>Is having SIA-licensed door staff enough?</h3>
              <p className="ed-desc">
                No - the campaign makes a clear distinction between staffing choices and the documented responsibilities that sit with the responsible person under the Act.
              </p>
            </div>

            <div className="faq-block">
              <span className="ed-label" style={{ color: 'var(--color-primary-navy)', marginBottom: '0.5rem' }}>Personnel</span>
              <h3 className="ed-subheading" style={{ marginBottom: '1rem' }}>Who does Martyn’s Law apply to?</h3>
              <p className="ed-desc">
                A common misconception is that Martyn's Law only applies to security companies. It doesn't. The duty sits with the organisation responsible for the premises or event, although security providers often help those organisations achieve compliance through risk assessments, procedures, training and operational measures.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 8. SLEEK FLOATING CTA BANNER */}
      <section style={{ background: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner-override"
            style={{ 
            backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,            
            borderRadius: '16px',
            padding: '3rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            gap: '2rem',
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
          }}>

            <div style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: 'var(--fs-h2)', letterSpacing: '-0.5px' }}>The Martyn's Law Readiness Guide.</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', margin: 0, maxWidth: '600px', lineHeight: 'var(--lh-body)' }}>
                Tier-by-tier requirements, the five questions a board should be asking today and a 90-day readiness checklist.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link 
                to="/contact" 
                className="btn btn-pill" 
                style={{ 
                  backgroundColor: 'var(--color-white)', 
                  color: 'var(--color-primary-navy)', 
                  fontWeight: '700', 
                  padding: '1rem 2.5rem', 
                  fontSize: 'var(--fs-body)',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'inline-block'
                }}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default MartynsLaw;